module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('section', {
    staticClass: "content",
    attrs: {
      "role": "main",
      "aria-label": "תוכן"
    }
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content",
    attrs: {
      "id": "team"
    }
  }, [_c('div', {
    staticClass: "fill"
  }, [_c('img', {
    key: _vm.img2srcD,
    staticClass: "fillImgBack",
    attrs: {
      "src": _vm.img2srcD,
      "alt": "מי אנחנו"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.img2src,
    staticClass: "fillImgFront",
    attrs: {
      "src": _vm.img2src,
      "alt": "מי אנחנו"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds textbox-bounds"
  }, [_c('div', {
    staticClass: "textbox-flex"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "memberFlex"
  }, _vm._l((_vm.texts.managment), function(member) {
    return _c('TeamMember', {
      attrs: {
        "parentComp": _vm.roundRef,
        "memberName": member.membername,
        "title": member.title,
        "picture": member.picture,
        "song": member.song,
        "info": member.info
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', [_vm._v("צוות החצר-צפון")])])]), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h4', [_vm._v("צוות מקצועי")])])]), _vm._v(" "), _c('div', {
    staticClass: "memberFlex"
  }, _vm._l((_vm.texts.managment2_north), function(member) {
    return _c('TeamMember', {
      attrs: {
        "parentComp": _vm.roundRef,
        "memberName": member.membername,
        "title": member.title,
        "picture": member.picture,
        "song": member.song,
        "info": member.info
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "memberFlex"
  }, _vm._l((_vm.texts.members_north), function(member) {
    return _c('TeamMember', {
      attrs: {
        "parentComp": _vm.roundRef,
        "memberName": member.membername,
        "title": member.title,
        "picture": member.picture,
        "song": member.song,
        "info": member.info
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h4', [_vm._v("משרד")])])]), _vm._v(" "), _c('div', {
    staticClass: "memberFlex"
  }, _vm._l((_vm.texts.office_north), function(member) {
    return _c('TeamMember', {
      attrs: {
        "parentComp": _vm.roundRef,
        "memberName": member.membername,
        "title": member.title,
        "picture": member.picture,
        "song": member.song,
        "info": member.info
      }
    })
  }), 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "fill"
  }, [_c('img', {
    key: _vm.img3srcD,
    staticClass: "fillImgBack",
    attrs: {
      "src": _vm.img3srcD,
      "alt": "מי אנחנו"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.img3src,
    staticClass: "fillImgFront",
    attrs: {
      "src": _vm.img3src,
      "alt": "מי אנחנו"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds textbox-bounds"
  }, [_c('div', {
    staticClass: "textbox-flex"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', [_vm._v("צוות החצר-מרכז")])])]), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h4', [_vm._v("צוות מקצועי")])])]), _vm._v(" "), _c('div', {
    staticClass: "memberFlex"
  }, _vm._l((_vm.texts.managment2), function(member) {
    return _c('TeamMember', {
      attrs: {
        "parentComp": _vm.roundRef,
        "memberName": member.membername,
        "title": member.title,
        "picture": member.picture,
        "song": member.song,
        "info": member.info
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "memberFlex"
  }, _vm._l((_vm.texts.members), function(member) {
    return _c('TeamMember', {
      attrs: {
        "parentComp": _vm.roundRef,
        "memberName": member.membername,
        "title": member.title,
        "picture": member.picture,
        "song": member.song,
        "info": member.info
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h4', [_vm._v("משרד")])])]), _vm._v(" "), _c('div', {
    staticClass: "memberFlex"
  }, _vm._l((_vm.texts.office), function(member) {
    return _c('TeamMember', {
      attrs: {
        "parentComp": _vm.roundRef,
        "memberName": member.membername,
        "title": member.title,
        "picture": member.picture,
        "song": member.song,
        "info": member.info
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', [_vm._v("מייסד")])])]), _vm._v(" "), _c('div', {
    staticClass: "memberFlex"
  }, _vm._l((_vm.texts.founder), function(member) {
    return _c('TeamMember', {
      attrs: {
        "parentComp": _vm.roundRef,
        "memberName": member.membername,
        "title": member.title,
        "picture": member.picture,
        "song": member.song,
        "info": member.info
      }
    })
  }), 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content double-content2",
    attrs: {
      "id": "FAQS"
    }
  }, [_c('div', {
    staticClass: "fill double-content2"
  }, [_c('img', {
    key: _vm.img8srcD,
    staticClass: "fillImgBack",
    attrs: {
      "src": _vm.img8srcD,
      "alt": "מי אנחנו"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.img8src,
    staticClass: "fillImgFront",
    attrs: {
      "src": _vm.img8src,
      "alt": "מי אנחנו"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds double-textbounds"
  }, [_c('div', {
    staticClass: "textbox textbox-right"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', [_vm._v("שאלות נפוצות")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('FAQ', {
    key: _vm.faq
  })], 1)], 1)])])])])]), _vm._v(" "), (_vm.showInfo) ? _c('TeamMemberInfo', {
    attrs: {
      "memberName": _vm.memberName,
      "title": _vm.title,
      "info": _vm.info,
      "picture": _vm.picture,
      "song": _vm.song
    },
    on: {
      "close": function($event) {
        _vm.showInfo = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-96b6acf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Team.vue
// module id = 123
// module chunks = 0